import { Component, Input, OnInit } from '@angular/core';
import { Concert } from 'src/app/models/(item)/concert/Concert.model';

@Component({
  selector: 'concert-item',
  templateUrl: './concert-item.component.html',
  styleUrls: ['./concert-item.component.css'],
})
export class ConcertItemComponent implements OnInit {
  @Input() concert: Concert;

  constructor() {}

  ngOnInit() {}

  spliceText(text) {
    if (text) {
      if (text?.length > 305) {
        text = text!.slice(0, 300) + '...';
      }
      return text;
    }
  }
}
